/*!
            _       __  __       _     _ _      __  __
           | |     |  \/  |     | |   (_) |    |  \/  |
  _ __ ___ | |_ ___| \  / | ___ | |__  _| | ___| \  / | ___ _ __  _   _
 | '_ ` _ \| __/ __| |\/| |/ _ \| '_ \| | |/ _ \ |\/| |/ _ \ '_ \| | | |
 | | | | | | || (__| |  | | (_) | |_) | | |  __/ |  | |  __/ | | | |_| |
 |_| |_| |_|\__\___|_|  |_|\___/|_.__/|_|_|\___|_|  |_|\___|_| |_|\__,_|



 *
 * mtcMobileMenu.js - A jQuery plugin to enable flyout menu
 * Verion : 1.0.1
 * Author(s) : Peter Fitzearl
 *
 * Docs: http://wiki.mtcmedia.co.uk/index.php?title=Flyout_menu
 * Website: http://www.mtcmedia.co.uk
 *
 */

;(function ( $, window, document, undefined ) {

    // Create the defaults once
    var pluginName = "mtcMobileMenu",
        plugin,
        defaults = {

            /* Primary Nav Options */
            buttonAppend: '#header > .wrapper',
            buttonHtml: '<a><span class="line"></span><span class="line"></span><span class="line"></span></a>',
            menuPosition: 'top', // 'right', 'top' or 'left', will add class to body,
            moveSite: true, // move rest of site on slide out
            enableDrag: true, // enable drag back of menu,
            dragThreshold: 50, //percentage of window width drag to trigger close
            outerWrapper: '.siteOuterWrapper ',
            flyoutWrapper: '.flyoutWrap',
            breakpoint: 640, //to which max width to keep menu functional, set to false to disable
            nestedAccordion: false, // will add accordion to nested links
            clone: true, // This will clone top level links and add to nested accordion to allow mobile taps, if top level link isn't important set to false
            nestedWrap: 'ul', // If sub category items are wrapped in a div change this to 'div'
            moreSubs: true // If menu has sublevels, set this to true
        };

    $.mtcMobileMenu = function( options ) {

        plugin = this;
        plugin.version = '1.0.1';
        plugin.settings = $.extend( {}, defaults, options );
        plugin._defaults = defaults;
        plugin._name = pluginName;
        init();

        // Init the plugin on load
        function init () {

            // not much required here
            // bind the resize event, debounce to prevent multiple runs
            $(window).on('resize', debounce(function(){ onResize(); }, 300, false));

            // if we're already in the correct breakpoint
            if((Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) <= plugin.settings.breakpoint || plugin.settings.breakpoint === false) {
                create();
            }

            if(plugin.settings.moreSubs) {
                addSubClasses();
            }
        }

        function showHideMenuContents() {

            var speed = 0,
                only_scroll_to = false,
                scroll_element = '';

            if ($('.mobileNavBlock').hasClass('fixed')) {
                speed = 800;

                if ($('#searchFormWrap').hasClass('formOpen') || $('.searchFilter').is(':visible')) {
                    $(plugin.settings.flyoutWrapper).removeClass('alive');
                }

                if ($(plugin.settings.flyoutWrapper).hasClass('alive')) {
                    only_scroll_to = true;
                }
            }

            if ($.browser.safari) {
                scroll_element = $('body');
            } else {
                scroll_element = $('html');
            }

            scroll_element.stop(true, false).animate({
                scrollTop: 0
            }, speed, function () {
                if (only_scroll_to === false) {
                    // If the menu is not open
                    if ($(plugin.settings.flyoutWrapper).is(':hidden')) {
                        // We use css so it just needs a class
                        $('.flyout').addClass('alive');

                        if (plugin.settings.moveSite) {
                            $(plugin.settings.outerWrapper).find('> div').addClass('alive');
                        } else {
                            $(plugin.settings.flyoutWrapper).addClass('alive');
                        }

                        if ($('#content #searchFormWrap').length > 0 && $('.js_scrollToSearch').length === 0) {
                            if ($('.js_offersMenuMobile').is(':visible')) {
                                $('.js_offersMenuMobile').slideUp(function () {
                                    $('.js_mobileOffersTrigger').removeClass('active');
                                    $(plugin.settings.flyoutWrapper).stop(true, true).slideDown();
                                });
                            } else {
                                $('#content #searchFormWrap').slideUp(function () {
                                    $(this).removeClass('formOpen');
                                    $('.js_triggerSearch').removeClass('active');
                                    $(plugin.settings.flyoutWrapper).stop(true, true).slideDown();
                                });
                            }
                        } else if ($('#content .searchFilter').length > 0) {

                            if ($('.js_offersMenuMobile').is(':visible')) {
                                $('.js_offersMenuMobile').slideUp(function () {
                                    $('.js_mobileOffersTrigger').removeClass('active');
                                    $(plugin.settings.flyoutWrapper).stop(true, true).slideDown();
                                });
                            } else {
                                $('#content .searchFilter').slideUp(function () {
                                    $('.js_triggerRefine').removeClass('active');
                                    $(plugin.settings.flyoutWrapper).stop(true, true).slideDown();
                                });
                            }
                        } else {
                            if ($('.js_offersMenuMobile').is(':visible')) {
                                $('.js_offersMenuMobile').slideUp(function () {
                                    $(plugin.settings.flyoutWrapper).stop(true, true).slideDown();
                                });
                            } else {
                                $(plugin.settings.flyoutWrapper).stop(true, true).slideDown();
                            }

                            $('.js_mobileOffersTrigger').removeClass('active');
                            $('.js_triggerSearch').removeClass('active');
                            $('.js_updateResults').removeClass('active');
                        }

                    } else {
                        // Remove class to toggle animation
                        $('.flyout').removeClass('alive');

                        if (plugin.settings.moveSite) {
                            $(plugin.settings.outerWrapper).find('> div').removeClass('alive');
                        } else {
                            $(plugin.settings.flyoutWrapper).removeClass('alive');
                        }

                        $(plugin.settings.flyoutWrapper).slideUp();

                        // Reset the height
                        resetMenuHeight();

                        if (plugin.settings.nestedAccordion) {
                            // Hide submenus
                            $(plugin.settings.flyoutWrapper + ' ' + plugin.settings.nestedWrap).hide().parent().removeClass('open');
                        }
                    }
                }
            });

        }

        // Create the menu functionality
        function create() {

            // We should only do this for first time load
            if(!(plugin.loaded)) {

                // determine the menu position
                plugin.position = (plugin.settings.menuPosition === 'left' ) ? 'left' : plugin._defaults.menuPosition; // Default to left if incorrect value

                // add class to body to position menu
                $('body').addClass('menu'+plugin.position);

                // If moving site we need to add an extra css class to fix transform z-index issue
                if(plugin.settings.moveSite) {
                    $(plugin.settings.outerWrapper).find('> div').addClass('transform');
                }

                // Create the button
                if($('.flyout').length <= 0){
                    var flyoutButton = $('<div />').addClass('flyout '+ plugin.settings.menuPosition ).html(plugin.settings.buttonHtml);

                    // Add button to the correct element
                    $(plugin.settings.buttonAppend).append(flyoutButton);
                }


                // bind click event to button
                $('.flyout').on('click', function () {

                    if ($('.hasFranchise').length > 0) {
                        $('.hasFranchise').slideUp(function () {

                            $('.hasFranchise').attr('style', '');
                            $('.hasFranchise').find('.open').removeClass('open');
                            $('.hasFranchise').find('.column ul').attr('style', '');
                            $('.hasFranchise').find('.sub').attr('style', '');

                            showHideMenuContents();

                        });
                    } else {
                        showHideMenuContents();
                    }
                });

                accordion();

                // NOTE: requires hammer.js v2.0 or later
                // If drag enabled
                if(plugin.settings.enableDrag) {
                    //delete Hammer.defaults.cssProps.userSelect;
                    $(plugin.settings.outerWrapper).hammer().bind("panstart panend panright panleft pantop", handleDrag);
                }

                // And we've loaded
                plugin.loaded = true;
            }
        }

        // On resize event
        function onResize () {

            if((Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) <= plugin.settings.breakpoint || plugin.settings.breakpoint === false) {
                // Recreate the menu if in the correct breakpoint
                create();
            } else {
                // Otherwise, we should probably destroy
                destroy();
            }
        }

        // Correct menu height on resize
        function correctMenuHeight () {

            // Set the height variables
/*            var menuHeight = $(plugin.settings.flyoutWrapper).outerHeight(),
                pageHeight = $(plugin.settings.outerWrapper).outerHeight(),
                windowHeight = $(window).height(),
                headerHeight = $('#header').outerHeight(),
                childrenHeight = 0;*/

            // Loop through children element to determine extended height
            /*$(plugin.settings.flyoutWrapper).children().each(function(){
                childrenHeight = childrenHeight + $(this).outerHeight();
            });

            // Debug log

            childrenHeight = childrenHeight + headerHeight;
            // If the menu is taller than the window, we best do something
            if(childrenHeight > windowHeight) {
                $(plugin.settings.outerWrapper).css({'height' : childrenHeight});
                $(plugin.settings.flyoutWrapper).css({'height' : childrenHeight});

            // Otherwise we need to make it full height
            } else {
                $(plugin.settings.outerWrapper).css({'height' : windowHeight});
                $(plugin.settings.flyoutWrapper).css({'height' : windowHeight});
            }*/

        }

        // Reset menu height
        function resetMenuHeight () {

            // Delay to prevent any resets before it's hidden
            setTimeout(function(){
                // We can reset the heights now
                $(plugin.settings.outerWrapper).css({'height' : ''});
                $(plugin.settings.flyoutWrapper).css({'height' : ''});

                //reset sub menu
                $(plugin.settings.flyoutWrapper + ' .column h4').removeClass('open');
                $(plugin.settings.flyoutWrapper + ' .column ul').attr('style', '');

            }, 500);

        }

        // Deal with the accordion if present
        function accordion () {

            if(plugin.settings.nestedAccordion) {

                $(plugin.settings.flyoutWrapper).on('click', 'ul li a', function(e){

                    if($(this).parent().find(plugin.settings.nestedWrap).length) {

                         //Checks if menu has more than 1 sub level
                        var findSub = plugin.settings.nestedWrap;
                        if(plugin.settings.moreSubs){
                            findSub = '> ' + plugin.settings.nestedWrap;
                        }

                        // If clone is set to true
                        if(plugin.settings.clone){

                            // Prepend parent clone to top of sub nav
                            if ($(this).parent().find('.clone').length == 0 && !$(this).parents('li').hasClass('megaMenu')){
                                var topLevelItem = $(this).clone().addClass('clone');
                                topLevelItem.prependTo($(this).parent().find(findSub).find('ul')).wrap('<li />');
                            }

                        }

                        // and if this isn't already open
                        if (!$(this).closest('li').hasClass('open')){

                            // To all those other open menus, time to hide
                            if(plugin.settings.moreSubs){
                                toggleItem($(this).closest('li').siblings('.open:visible'));
                            } else {
                                $('.open:visible').find(plugin.settings.nestedWrap).not(':animated').slideToggle(500, function(){ $(this).css('display', ''); }).closest('li').toggleClass('open');
                            }

                            // Get this menu open and correct the menu height if it's longer than the page
                            $(this)
                            .parent()
                            .find(findSub)
                            .not(':animated')
                            .slideToggle(500, function() { /*correctMenuHeight();*/ })
                            .closest('li')
                            .toggleClass('open');
                        } else {
                            // Get the submenu, slide it up, remove its class, party
                            $(this)
                            .parent()
                            .find(findSub)
                            .not(':animated')
                            .slideToggle(500, function() { /*correctMenuHeight();*/ $(this).css('display', ''); })
                            .closest('li')
                            .toggleClass('open');
                        }
                        // Prevent the default action of the click event
                        e.preventDefault();
                    }

                });

                $(plugin.settings.flyoutWrapper).on('click', 'h4', function(e) {

                    if (!$(this).hasClass('open')) {
                        $(this)
                        .addClass('open')
                        .parent().find('ul')
                        .stop(true, true)
                        .slideToggle(500, function() { /*correctMenuHeight();*/ })
                    } else {
                        $(this)
                        .removeClass('open')
                        .parent().find('ul')
                        .stop(true, true)
                        .slideToggle(500, function() { /*correctMenuHeight();*/ })
                    }

                });

            } else {
                // Make sure they remain hidden
                $(plugin.settings.nestedClass).hide();
            }
        }

        // Hide opened menus recursively (pass li element)
        function toggleItem (item) {
            if(item.hasClass('open')){
                if(item.find('> ' + plugin.settings.nestedWrap)){
                    item.find('> ' + plugin.settings.nestedWrap).find('> li').each(function() {
                        toggleItem($(this));
                    });
                }
                item.find('> ' + plugin.settings.nestedWrap).not(':animated').slideToggle(500, function(){ correctMenuHeight(); $(this).css('display', ''); }).closest('li').toggleClass('open');
            }
        }

        // Adds class for parent that has submenu
        function addSubClasses () {
            $(plugin.settings.flyoutWrapper + ' > ' + plugin.settings.nestedWrap).find('li').each(function() {
                if($(this).find(plugin.settings.nestedWrap).length){
                    $(this).addClass('parent');
                }
            });
        }

        // Debounce function delays function to prevent multiple calls
        function debounce (func, threshold, noDelay) {

            var timeout;

            return function debounced () {
                var obj = this, args = arguments;
                function delayed () {
                    if (!noDelay)
                        func.apply(obj, args);
                    timeout = null;
                };

                if (timeout)
                    clearTimeout(timeout);
                else if (noDelay)
                    func.apply(obj, args);

                timeout = setTimeout(delayed, threshold || 100);
            };
        }

        // Handle the drag event
        function handleDrag (ev) {

            //var menuHeight = (plugin.settings.outerWrapper).css({'height' : ''});

            if($('.alive').length) {

                var windowWidth = $(window).width();

                // Swith event for the type of gesture
                switch(ev.type) {
                    case 'panright':
                        // If flyout is alive and drag is not outside viewport
                        if((plugin.position === 'right') && 80 - ((ev.gesture.distance/windowWidth)*100) > 0){
                            if(Math.abs(ev.gesture.distance) > ((windowWidth/100)*plugin.settings.dragThreshold) && ev.gesture.direction == 4) {
                              $('.alive').trigger( "click" );
                            }
                        }
                    break;

                    case 'panleft':
                        // If flyout is alive and drag is not outside viewport
                        if((plugin.position === 'left') && 80 - ((ev.gesture.distance/windowWidth)*100) > 0){
                            if(Math.abs(ev.gesture.distance) > ((windowWidth/100)*plugin.settings.dragThreshold) && ev.gesture.direction == 2) {
                              $('.alive').trigger( "click" );
                            }
                        }
                    break;

                    case 'pantop':

                    break;
                }
            }
        }

        // Destroy the plugin
        function destroy (element, settings) {

            // Remove the alive class to reset css
            $('.alive').removeClass('alive');

            // Remove any tranform class'
            $('.transform').removeClass('transform');

            // Reset the menu height
            resetMenuHeight();

            // Remove body class
            $('body').removeClass('menu'+plugin.position);

            // Remove click
            $('.flyout').off('click');

            // If accordion
            if(plugin.settings.nestedAccordion) {

                // Get rid of the clones
                $('.clone').parent().detach();

                // Brings back the dropdown hover in desktop mode
                $(plugin.settings.flyoutWrapper).find('li '+plugin.settings.nestedWrap).css('display', '')
                .closest('li')
                .removeClass('open');

                // Remove the binded click event
                $(plugin.settings.flyoutWrapper).off('click', 'ul li a');
            }
            // Unload
            plugin.loaded = false;
        }
    };

    $.fn[ pluginName ] = function ( options ) {
        this.each(function() {
            if ( !$.data( this, "plugin_" + pluginName ) ) {
                $.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
            }
        });

        return this;
    };

})( jQuery, window, document );